import React from "react"
import {CustomAccountActiveWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const CustomAccountActive = ({children}) => {
  return <CustomAccountActiveWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomAccountActiveWrapper>
}
export default CustomAccountActive



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomAccountActive/index.js